export default __webpack_public_path__ + "static/media/userWhite.f49368d7.svg";